export default __webpack_public_path__ + "static/media/Footpad's Bracers of Engulfing Twilight.6394f642.jpg";